/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
 import { getAllHashicorpUsers } from './hashicorpAction';
   
const initialState = {
    data: {},
    hashicorpUsers:[], 
}
const hashicorpSlice = createSlice({
    name: 'hashicorp',
    initialState,
    extraReducers: {

        [getAllHashicorpUsers.fulfilled]: (state, { payload }) => {
            state.hashicorpUsers =  payload;
        },
      
    }
});

export default hashicorpSlice.reducer